import { apolloClient } from '@/setup/apollo-setup';
import { error } from '@/utils/notification';
// import datastore from "@/developing/datastore";

import {
  GET_LATEST_MESSAGE_ALL_CHANNELS,
  GET_RECENT_MESSAGE_LIST,
  GET_MESSAGE_TOPICS_BY_IDS,
  GET_MESSAGES_BY_IDS,
  CHECK_COMMUNICATION_UPDATE
} from '@/queries/modules/communication';

export async function getLatestMessageAllChannels(context, payload) {

  context.commit('setProcessing', true);

  try {
    // Send Teacher ID to get User UUID to get subscribe ID
    const { id, uuid, code } = this._vm.$currentUser;

    // Restore Message Indexes from IndexedDB

    // Try to get new pending message from server (Semi-syncing)

    const result = await apolloClient
      .query({
        query: GET_LATEST_MESSAGE_ALL_CHANNELS,
        variables: {
          uuid, id, code,
          ...payload,
        },
        // fetchPolicy: "no-cache"
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      });

    const { data } = result;

    if (result || data) {

      // context.commit('setSuccess', null);
      const success = true;
      const error = null;

      // const { pm, chat, webboard } = data.getLatestMessageAllChannels;
      // // console.log("check raw data", data, pm);

      // // Create Message
      // storeMessagesToCache({ channel: "pm", messageKey: "privateMessageReplies", data: pm });
      // storeMessagesToCache({ channel: "chat", messageKey: "chatMessage", data: chat });
      // storeMessagesToCache({ channel: "webboard", messageKey: "webBoardReplies", data: webboard });

      return { status: { success, error }, data: data.getLatestMessageAllChannels };

    }

    throw new Error("No classroom state data");

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e } };
  }
}

export async function getRecentMessageList(context, payload = {}) {
  // console.log("Store Dispatching getRecentMessageList", context, payload);
  // context.commit('setProcessing', true);

  try {
    const { id, uuid, code } = this._vm.$currentUser;

    const response = await apolloClient
      .query({
        query: GET_RECENT_MESSAGE_LIST,
        variables: {
          uuid, id, code,
          ...payload,
        },
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      });

    const { data } = response;

    if (data) {

      // context.commit('setSuccess', null);
      const success = true;
      const error = null;

      return { status: { success, error }, data: data.getRecentMessageList };

    }

    // throw new Error("No classroom state data");

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e } };
  }
}

export async function getMessageTopicsByIds(context, payload = {}) {
  const location = "Vuex/Store/Communication/Actions/getMessageTopicsByIds";

  // console.log("Store Dispatching", location, context, payload);

  try {
    const { list, channel } = payload;
    if (!list || !channel) {
      return { status: { success: false, error: true, message: "Invalid payload", location } };
    }

    const { id, uuid, code } = this._vm.$currentUser;

    const response = await apolloClient
      .query({
        query: GET_MESSAGE_TOPICS_BY_IDS,
        variables: {
          uuid, id, code,
          ...payload,
        },
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      });

    const { data } = response;

    if (data) {

      // context.commit('setSuccess', null);
      const success = true;
      const error = null;

      return { status: { success, error }, data: data.getMessageTopicsByIds };

    }

  //   // throw new Error("No classroom state data");

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e, location } };
  }
}

export async function getMessagesByTopicId(context, payload = {}) {
  const location = "Vuex/Store/Communication/Actions/getMessagesByTopicId";

  // console.log("Store Dispatching", location, context, payload);
  try {
    const { list, channel } = payload;

    if (!list || !channel) {
      return { status: { success: false, error: true, message: "Invalid payload", location } };
    }

    const { id, uuid, code } = this._vm.$currentUser;

    const response = await apolloClient
      .query({
        query: GET_MESSAGE_TOPICS_BY_IDS,
        variables: {
          uuid, id, code,
          ...payload,
        },
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      });

    const { data } = response;

    if (data) {

      // context.commit('setSuccess', null);
      const success = true;
      const error = null;

      return { status: { success, error }, data: data.getMessageTopicsByIds };

    }

  //   // throw new Error("No classroom state data");

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e, location } };
  }
}

export async function getMessagesByIds(context, payload = {}) {
  const location = "Vuex/Store/Communication/Actions/getMessagesByIds";

  // console.log("Store Dispatching", location, context, payload);
  try {
    const { list, channel } = payload;
    if (!list || !channel) {
      return { status: { success: false, error: true, message: "Invalid payload", location } };
    }

    const { id, uuid, code } = this._vm.$currentUser;

    const response = await apolloClient
      .query({
        query: GET_MESSAGES_BY_IDS,
        variables: {
          uuid, id, code,
          ...payload,
        },
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      });

    const { data } = response;

    if (data) {

      // context.commit('setSuccess', null);
      const success = true;
      const error = null;

      return { status: { success, error }, data: data.getMessagesByIds };

    }

  //   // throw new Error("No classroom state data");

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e, location } };
  }
}

export async function checkUpdate(context, payload = {}) {
  const location = "Vuex/Store/Communication/Actions/checkUpdate";

  // console.log("Store Dispatching", location, context, payload);

  try {
    const { channel, type, id } = payload;
    // const { list, channel } = payload;
    if (!channel || !type || !id) {
      return { status: { success: false, error: true, message: "Invalid payload", location } };
    }

    const { id: user_id, uuid, code } = this._vm.$currentUser;

    const response = await apolloClient
      .query({
        query: CHECK_COMMUNICATION_UPDATE,
        variables: {
          uuid, user_id, code,
          ...payload,
        },
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      });

    const { data } = response;

    if (data) {

      const success = true;
      const error = null;

      return { status: { success, error }, data: data.checkCommunicationUpdate };

    }

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e, location } };
  }
}
